import React, { Component } from 'react';

class ServicesGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeCategory: 'all'
    };
  }

  render() {
    const {
      data,
      columns = 2,
      showCategories = false,
      hideHeader = false,
      sectionClass = "p-80px-tb",
      bgClass = ""
    } = this.props;

    const { activeCategory } = this.state;

    // カラム数に応じたCSSクラス設定
    const colClass = columns === 3 ? "col-lg-4 col-md-6" :
                     columns === 2 ? "col-lg-6 col-md-6" :
                     "col-lg-12";

    // サービスデータを配列形式に変換
    const servicesArray = [];
    if (data) {
      Object.keys(data).forEach(key => {
        if (key !== 'pageTitle' && key !== 'pageSubtitle' && data[key].title) {
          servicesArray.push({
            id: key,
            ...data[key],
            category: this.getCategoryFromKey(key)
          });
        }
      });
    }

    // カテゴリーリストの生成
    const categories = showCategories ?
      ['all', ...new Set(servicesArray.map(service => service.category))] :
      ['all'];

    // フィルタリング
    const filteredServices = activeCategory === 'all' ?
      servicesArray :
      servicesArray.filter(service => service.category === activeCategory);

    return (
      <section className={`services-premium-section ${sectionClass}`}>
        {/* 美しい背景レイヤー */}
        <div className="services-background">
          <div className="bg-main-image"></div>
          <div className="bg-overlay"></div>
          <div className="floating-elements">
            <div className="floating-shape shape-1"></div>
            <div className="floating-shape shape-2"></div>
            <div className="floating-shape shape-3"></div>
          </div>
        </div>

        <div className="container">
          {/* ページタイトル */}
          {!hideHeader && data.pageTitle && (
            <div className="row">
              <div className="col-lg-8 offset-lg-2">
                <div className="services-header text-center m-60px-b">
                  <h2 className="services-main-title">{data.pageTitle}</h2>
                  {data.pageSubtitle && (
                    <p className="services-subtitle">{data.pageSubtitle}</p>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* エレガントなカテゴリフィルター */}
          {showCategories && categories.length > 1 && (
            <div className="row m-40px-b">
              <div className="col-md-12 text-center">
                <div className="services-filter-group">
                  {categories.map((category, i) => (
                    <button
                      key={i}
                      type="button"
                      className={`services-filter-btn ${activeCategory === category ? 'active' : ''}`}
                      onClick={() => this.setState({ activeCategory: category })}
                    >
                      {this.getCategoryDisplayName(category)}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* プレミアムサービスカードグリッド */}
          <div className="services-grid">
            {filteredServices.map((service, i) => (
              <div key={service.id} className="services-card-wrapper" style={{animationDelay: `${i * 0.1}s`}}>
                <div className="services-premium-card">
                  {/* カード背景グラデーション */}
                  <div className="card-background-gradient"></div>

                  {/* サービスアイコン */}
                  <div className="service-icon-wrapper">
                    <div className="service-icon">
                      <i className={service.benefits && service.benefits[0] ? service.benefits[0].icon : 'icofont-gear'} />
                    </div>
                  </div>

                  {/* サービス核心情報 */}
                  <div className="service-content">
                    <div className="service-text-content">
                      <h3 className="service-premium-title">
                        {service.title}
                      </h3>

                      {service.lead && (
                        <p className="service-premium-lead">
                          {service.lead}
                        </p>
                      )}

                      {service.content && (
                        <p className="service-premium-description">
                          {service.content}
                        </p>
                      )}
                    </div>

                    {/* キーメリット（最大3つ） */}
                    {service.benefits && service.benefits.length > 0 && (
                      <div className="service-benefits-preview">
                        {service.benefits.slice(0, 3).map((benefit, j) => (
                          <div key={j} className="benefit-preview-item">
                            <i className="icofont-check-circle"></i>
                            <span>{benefit.title.replace(/【.*?】/, '')}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  {/* プレミアムアクションボタン */}
                  <div className="service-premium-action">
                    <a href="/contact" className="btn-premium-action">
                      <span>詳細を相談する</span>
                      <i className="icofont-arrow-right"></i>
                    </a>
                  </div>

                  {/* カテゴリバッジ */}
                  {showCategories && service.category && (
                    <div className="service-premium-badge">
                      {this.getCategoryDisplayName(service.category)}
                    </div>
                  )}

                  {/* ホバー効果用グロー */}
                  <div className="card-glow-effect"></div>
                </div>
              </div>
            ))}
          </div>

          {/* プレミアムCTAセクション */}
          <div className="services-premium-cta">
            <div className="cta-content">
              <h3 className="cta-title">どのサービスが最適かお悩みですか？</h3>
              <p className="cta-subtitle">無料相談で、貴社に最適なソリューションをご提案いたします。</p>
              <a href="/contact" className="btn-premium-cta">
                <span>無料相談を申し込む</span>
                <i className="icofont-rocket-alt-2"></i>
              </a>
            </div>
          </div>
        </div>
      </section>
    );
  }

  // キーからカテゴリを推定
  getCategoryFromKey(key) {
    const categoryMap = {
      'fastDev': 'development',
      'nurturingDev': 'education',
      'specDrivenDev': 'development',
      'customBot': 'automation'
    };
    return categoryMap[key] || 'other';
  }

  // カテゴリ表示名を取得
  getCategoryDisplayName(category) {
    const displayNames = {
      'all': 'すべて',
      'development': '開発サービス',
      'education': '教育・支援',
      'automation': '自動化',
      'other': 'その他'
    };
    return displayNames[category] || category;
  }
}

export default ServicesGrid;